<template>
    <div class="AddRiskRequirement">
        <NewCustomDropdown
            v-if="enabled"
            :items="availableRequirementOptions"
            search-placeholder="Search requirements..."
            no-results-text="No matching requirements found"
            position-x="end"
            position-y="bottom"
            :item-size="48"
            popover-teleported
            popover-reposition-on-scroll
            @select="selectRequirement"
        >
            <template #trigger="{ toggle }">
                <NewButton
                    variant="fill"
                    color="primary"
                    @click="toggle"
                >
                    <EidIcon :icon-src="faPlus" />
                    <span>Add Requirement</span>
                    <EidIcon :icon-src="faAngleDown" />
                </NewButton>
            </template>

            <template #item="{ item }">
                <div class="AddRiskRequirement__optionContent">
                    <EidIcon
                        :icon-src="getRequirementTypeIcon(item.value)"
                        class="AddRiskRequirement__optionIcon"
                        :svg-props="{ width: 20 }"
                    />
                    <span class="AddRiskRequirement__optionLabel">{{ item.label }}</span>
                </div>
            </template>
        </NewCustomDropdown>
    </div>
</template>

<style lang="scss">
    .AddRiskRequirement {
        &__optionContent {
            display: flex;
            align-items: center;
        }

        &__optionIcon {
            margin-right: 8px;
        }

        &__optionLabel {
            font-size: 14px;
            font-weight: 500;
        }

        .NewCustomDropdown .Popover__popper {
            right: 0;
        }
    }
</style>

<script lang="ts">
    import { defineComponent, PropType } from 'vue';

    import { faAngleDown, faPlus } from '@fortawesome/pro-light-svg-icons';

    import NewCustomDropdown from '@evidentid/dashboard-commons/components/Dropdown/NewCustomDropdown.vue';
    import { DropdownOption } from '@evidentid/dashboard-commons/components/Dropdown/types';
    import EidIcon from '@evidentid/dashboard-commons/components/EidIcon/EidIcon.vue';
    import { TprmRequirementType } from '@evidentid/tprm-portal-lib/models/entity-details';

    import NewButton from '@/components/new-button/NewButton.vue';
    import { getRequirementTypeIconUri } from '@/modules/entity-details/utils/getRequirementTypeIconUri';

    export default defineComponent({
        name: 'AddRiskRequirement',
        components: {
            NewButton,
            EidIcon,
            NewCustomDropdown,
        },
        props: {
            availableRequirementOptions: {
                type: Array as PropType<DropdownOption<TprmRequirementType>[]>,
                default: (): DropdownOption<TprmRequirementType>[] => [],
            },
            enabled: {
                type: Boolean,
                default: true,
            },
        },
        emits: [ 'select' ],
        data() {
            return {
                faPlus,
                faAngleDown,
            };
        },
        methods: {
            selectRequirement(option: DropdownOption<TprmRequirementType>): void {
                this.$emit('select', option);
            },
            getRequirementTypeIcon: getRequirementTypeIconUri,
        },
    });
</script>
